import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Navigate, Outlet, useLocation, useNavigation } from "react-router-dom";
import NoActiveContractBanner from "@/components/NoActiveContractBanner";
import Sidebar from "@/components/Sidebar";
import { LoadingScreen } from "@/components/ui";
import { useAuth } from "@/context/auth/AuthContext";
import { usePortalNavigationAccess } from "@/hooks/usePortalNavigationAccess";
import { SessionTimeoutProvider } from "@/providers/SessionTimeoutProvider";
import { cn } from "@/utils/styleHelper";
export default function DashboardLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigation = useNavigation();
    const { isAuthenticated, isLoading, initialized } = useAuth();
    const { isLoading: isNavigationAccessLoading } = usePortalNavigationAccess(isAuthenticated);
    const location = useLocation();
    // Show loading screen while checking authentication
    if (!initialized || isLoading || isAuthenticated && isNavigationAccessLoading) {
        return /*#__PURE__*/ _jsx(LoadingScreen, {});
    }
    // If not authenticated, redirect to login
    if (!isAuthenticated) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: "/login",
            state: {
                from: location
            },
            replace: true
        });
    }
    // User is authenticated, render the dashboard layout
    return /*#__PURE__*/ _jsx(SessionTimeoutProvider, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "font-aeonik text-black",
            children: [
                sidebarOpen && /*#__PURE__*/ _jsx("div", {
                    className: "fixed inset-0 bg-black bg-opacity-50 z-50 lg:hidden",
                    onClick: ()=>setSidebarOpen(false),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "fixed left-0 top-0 h-full w-72 bg-[#171628] shadow-xl z-60 transition-transform duration-300",
                        onClick: (e)=>e.stopPropagation(),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "flex flex-col h-full px-6 pb-4",
                            children: /*#__PURE__*/ _jsx(Sidebar, {})
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-col h-full bg-[#171628] px-6 pb-4",
                        children: /*#__PURE__*/ _jsx(Sidebar, {})
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "sticky top-0 z-40 flex items-center gap-x-6 bg-[#171628] px-4 py-4 shadow-sm lg:hidden",
                    children: [
                        /*#__PURE__*/ _jsxs("button", {
                            type: "button",
                            className: "p-2 text-white",
                            onClick: ()=>setSidebarOpen(true),
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "sr-only",
                                    children: "Open sidebar"
                                }),
                                /*#__PURE__*/ _jsx("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    fill: "currentColor",
                                    viewBox: "0 0 16 16",
                                    children: /*#__PURE__*/ _jsx("path", {
                                        fillRule: "evenodd",
                                        d: "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex-1 text-base font-normal leading-6 text-white",
                            children: "Portal"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("main", {
                    className: "lg:pl-72",
                    children: [
                        /*#__PURE__*/ _jsx(NoActiveContractBanner, {}),
                        /*#__PURE__*/ _jsx("div", {
                            className: cn("bg-background-1 min-h-screen", {
                                "opacity-50": navigation.state === "loading"
                            }),
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "w-full",
                                children: /*#__PURE__*/ _jsx(Outlet, {})
                            })
                        })
                    ]
                })
            ]
        })
    });
}
